import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CargoPaymentInfo } from '../../../models/cargo-payment-info.model';

@Component({
  selector: 'app-account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountInformationComponent {
  @Input() cargoPaymentInfo?: CargoPaymentInfo;
}
